import React from 'react';
import { GiftIcon } from 'lucide-react';
type Bonus = {
  number: string;
  title: string;
  price: string;
  body: string;
  image: string;
  alt: string;
};
const bonuses: Bonus[] = [{
  number: 'Bonus 01',
  title: 'The Client Clarity Questionnaire',
  price: '$17',
  body: 'Walk in already knowing. The pre-wedding intake you send three to four weeks out — VIPs, the family situations you’d rather learn about now than at the altar, must-haves, timeline realities — plus a printable one-page day-of priority card that lives in your bag.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/2edc9ba5-ef53-4929-9e1a-85306f227df5.jpg',
  alt: 'Printed questionnaire on a clipboard beside a priority card and a lens cap'
}, {
  number: 'Bonus 02',
  title: 'The Wedding Week Email Pack',
  price: '$19',
  body: 'Never stare at a blank email the week of. Five copy-paste client emails for the final stretch — the confirmations you need, the details you need from them, the day-before check-in — plus the follow-up strategy for couples who don’t reply.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/f91e92d5-7d3d-45a1-9053-e871b96768d8.jpg',
  alt: 'Smartphone showing an email thread beside a laptop and a coffee cup'
}, {
  number: 'Bonus 03',
  title: 'The No-Panic Gear Checklist',
  price: '$9',
  body: 'Kill the 3 a.m. “did I charge the…”. A packing system built around what each part of the day actually needs, with the why behind each rule (why the backup body is non-negotiable), and a compact one-page version for the camera bag.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/0c8f2ee8-4845-4cbd-8832-a33e0dbb9bde.jpg',
  alt: 'Open camera bag with two bodies, batteries and a printed checklist in the pocket'
}, {
  number: 'Bonus 04',
  title: 'The Venue Walkthrough Note Sheet',
  price: '$12',
  body: 'Arrive with a plan instead of a hope. What to note on the walkthrough — light by hour, restrictions, the rain spot, the first-look spot, and why distance to the ceremony exit beats background quality when you pick the formals spot — with a decision map and an “if you can’t visit in advance” section for the morning-of recon.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/23761083-3ec7-4a6a-b155-eda6b4aef413.jpg',
  alt: 'Note sheet with a hand-drawn venue sketch, a pencil and a compact camera'
}, {
  number: 'Bonus 05',
  title: 'The Calm Authority Phrase Book',
  price: '$19',
  body: 'The words for the moments that test you. Sixty-eight categorized phrases: the aunt who’s directing your formals, the guest with the iPad in the aisle, the coordinator who’s 40 minutes behind, the “we’re late — here’s what we do” conversation. Includes a “what not to say” section and an exercise to pick the five phrases that sound like you.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/01db7054-d910-4218-98c1-6cf1ee11645e.jpg',
  alt: 'Small printed phrase booklet open on a table beside a camera strap'
}];
export function Bonuses() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-32" data-mp="1xltsmzlz8h2b">
      <div className="mx-auto max-w-6xl px-5" data-id="element-33" data-mp="1xk8y39znwy4g">
        <div className="text-center" data-id="element-34" data-mp="1tkicrlswna7b">
          <span className="inline-flex items-center gap-2 border border-gold-soft bg-gold-tint px-4 py-2 text-[10px] uppercase tracking-[0.22em] text-ink-soft" data-id="element-35" data-mp="1tjgogfmvor7n">
            <GiftIcon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-36" data-mp="1jup0eikxur20" />
            5 field bonuses included free
          </span>
          <h2 className="mt-8 font-serif text-3xl sm:text-5xl text-ink" data-id="element-37" data-mp="1ew41qnlc4ffo">
            Total value: $76 <span className="text-gold-dark" data-id="element-38" data-mp="19xap0xdvgsgk">→ free</span> with Direct the
            Day
          </h2>
          <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-39" data-mp="15tcn6ex5x3jt" />
        </div>

        <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-40" data-mp="10wm8nw10ag0i">
          {bonuses.map(bonus => <li key={bonus.number} className="flex flex-col overflow-hidden border border-gold-soft/70 bg-ivory" data-id="element-41" data-mp="30z3ur9c8pjtl">
              <img src={bonus.image} alt={bonus.alt} className="h-44 w-full object-cover" loading="lazy" data-id="element-42" data-mp="2r897c1n9ce6k" />
              <div className="flex flex-1 flex-col p-7" data-id="element-43" data-mp="2w4rd94ubqikh">
                <div className="flex items-center justify-between gap-3" data-id="element-44" data-mp="2h91stb4sedhv">
                  <span className="text-[10px] uppercase tracking-[0.24em] text-gold-dark" data-id="element-45" data-mp="2m96ctb4wlqcu">
                    {bonus.number}
                  </span>
                  <span className="inline-flex items-center gap-2 text-xs" data-id="element-46" data-mp="28b84amd9ko59">
                    <s className="text-ink-muted" data-id="element-47" data-mp="2d8rp654gvz66">{bonus.price}</s>
                    <span className="bg-ink px-2.5 py-1 text-[10px] uppercase tracking-[0.16em] text-gold" data-id="element-48" data-mp="6hihtl9ga7wo">
                      Free
                    </span>
                  </span>
                </div>
                <h3 className="mt-4 font-serif text-xl leading-snug text-ink" data-id="element-49" data-mp="llv22ezjhigk">
                  {bonus.title}
                </h3>
                <p className="mt-4 flex-1 text-[15px] leading-relaxed text-ink-soft" data-id="element-50" data-mp="gnjr20xid1wr">
                  {bonus.body}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}